import { Theme, ThemeOptions } from '@mui/material';
import { createBaseTheme, themeColors } from '@ianesthesie-kit/config';

// TODO move to kit3

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    empty: true;
  }
}

export const createAppTheme = (locale?: string): Theme => {
  const appThemeOptions: ThemeOptions = {
    components: {
      MuiToggleButton: {
        styleOverrides: {
          root: {
            textTransform: 'none'
          }
        }
      },
      MuiChip: {
        defaultProps: {
          size: 'small'
        },
        styleOverrides: {
          root: {
            height: 'unset',
            borderRadius: 6,
            padding: '0 4px',
            fontSize: '0.875rem'
          },
          filled: {
            border: '1px solid transparent',
            borderColor: 'transparent'
          },
          label: {
            width: '100%'
          },
          clickable: {
            boxShadow: 'none !important'
          },
          deleteIcon: {
            marginLeft: 2,
            transition: 'transform 0.25s ease',
            '&:hover': {
              transform: 'scale(1.2)'
            }
          }
        },
        variants: [
          {
            props: { color: 'success' },
            style: {
              backgroundColor: `${themeColors.green[100]} !important`,
              color: themeColors.green[800]
            }
          },
          {
            props: { color: 'warning' },
            style: {
              backgroundColor: `${themeColors.yellow[100]} !important`,
              color: themeColors.yellow[800]
            }
          },
          {
            props: { color: 'error' },
            style: {
              fontWeight: 500,
              backgroundColor: `${themeColors.red[100]} !important`,
              color: themeColors.red[800]
            }
          },
          {
            props: { variant: 'empty' },
            style: {
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              color: themeColors.slate[500]
            }
          }
        ]
      },
      MuiButton: {
        defaultProps: {
          variant: 'contained',
          disableElevation: true
        },
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: 8,
            fontWeight: 500
          }
        }
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: '#f1f5f9'
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            backgroundColor: themeColors.slate[50]
          }
        }
      },
      MuiCard: {
        defaultProps: {
          elevation: 0
        },
        styleOverrides: {
          root: {
            boxShadow: 'none',
            padding: '16px'
          }
        }
      }
    }
  };

  return createBaseTheme({
    locale,
    themeOptions: appThemeOptions,
    responsiveFonts: false
  });
};
